import { LanguagesIsoEnum } from "@/modules/assessments/types/test.interface";

export const DEFAULT_LOCALE = LanguagesIsoEnum.enUS;

export interface LocaleContextValue {
  locale: LanguagesIsoEnum;
  setLocale: (locale: LanguagesIsoEnum) => Promise<void>;
}
